import AdminPhotos from './AdminPhotos';
import {connect} from 'react-redux';
import {deleteCoverPageImage, updateAdminCoverPageImages, uploadCoverPageImage} from '../../ducks/adminPhotos';

const mapStateToProps = (state) => ({
  images: state.adminPhotos && state.adminPhotos.large,
});

const mapDispatchToProps = (dispatch) => {
  return ({
    onLoad: () => dispatch(updateAdminCoverPageImages()),
    onUploadImage: (file) => dispatch(uploadCoverPageImage(file)),
    onDeleteImage: (image) => dispatch(deleteCoverPageImage(image)),
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminPhotos);